// eslint-disable-next-line import/no-cycle
import {
  DEPARTMENT_GET_LIST,
  DEPARTMENT_GET_LIST_SUCCESS,
  DEPARTMENT_GET_LIST_ERROR,
  POSITION_GET_LIST,
  POSITION_GET_LIST_SUCCESS,
  POSITION_GET_LIST_ERROR,
} from '../actions';

export const departmentGetList = (callback) => ({
  type: DEPARTMENT_GET_LIST,
  callback
})
export const departmentGetListSuccessed = (data) => ({
  type: DEPARTMENT_GET_LIST_SUCCESS,
  payload: data,
});
export const departmentGetListFailed = (error) => ({
  type: DEPARTMENT_GET_LIST_ERROR,
  payload: error
});

export const positionGetList = () => ({
  type: POSITION_GET_LIST,
})
export const positionGetListSuccessed = (data) => ({
  type: POSITION_GET_LIST_SUCCESS,
  payload: data,
});
export const positionGetListFailed = (error) => ({
  type: POSITION_GET_LIST_ERROR,
  payload: error
});